export const ASYNC_FETCH = 'ILD_EffectiveDate/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_ILDEFFECTIVEDATE = 'ILD_EffectiveDate/ASYNC_FETCH_SUCCESS_ILDEFFECTIVEDATE';
export const ASYNC_FETCH_ILDFAILURE = 'ILD_EffectiveDate/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_ILDINVALIDATE = 'ILD_EffectiveDate/ASYNC_FETCH_INVALIDATE';
export const SET_SELECTED_ILDEFFECTIVE_DATE = 'ILD_EffectiveDate/SET_SELECTED_EFFECTIVE_DATE';
/**
 * action types
 * @type {string}
 */
 export const formatDate = (val) => {
    const value = new Date(val);
    let date = value.getDate();
    let month = value.getMonth() + 1; // January is 0!
    const year = value.getFullYear();
    if (date < 10) {
      date = '0' + date;
    }
    if (month < 10) {
      month = '0' + month;
    }
  
    return month + '/' + date + '/' + year;
  };